/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, message, Button, Modal } from "antd";
import { GoLocation, BiHome } from "react-icons/all";
import { useLeaflet, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import L from "leaflet";
import functions from "./index.functions";
import oRest from "../../../apis/rest";

const API_URL = "webhook/dataquery/?qname=";

const MarkerCluster = () => {
  const { map } = useLeaflet();
  const [bounds, setBounds] = useState(map.getBounds());
  const [zoom, setZoom] = useState(map.getZoom());
  const [markers, setMarkers] = useState({ type: 0, data: [] });
  const [focusPesantren, setFocusPesantren] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalDetail, setModalDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const onMove = useCallback(() => {
    setBounds(map.getBounds());
  }, [map]);

  const onZoom = useCallback(() => {
    setZoom(map.getZoom());
  }, [map]);

  useEffect(() => {
    map.on("moveend", onMove);
    return () => {
      map.off("moveend", onMove);
    };
  }, [map, onMove]);

  useEffect(() => {
    map.on("zoomend", onZoom);
    return () => {
      map.off("zoomend", onZoom);
    };
  }, [map, onZoom]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (zoom <= 7) {
          const { data } = await oRest.get(
            `${API_URL}kemenag_peta_sebaran_provinsi`
          );

          setMarkers({
            type: 1,
            data: data.map((e) => ({
              center: [e.lat, e.lon],
              content: e.total,
              info: e.provinsi,
            })),
          });
        } else if (zoom < 12) {
          const { data } = await oRest.get(
            `${API_URL}kemenag_peta_sebaran_kota`
          );

          setMarkers({
            type: 2,
            data: data.map((e) => ({
              center: [e.lat, e.lon],
              content: e.total,
              info: e.kota,
            })),
          });
        } else {
          const nortEast = bounds.getNorthEast();
          const southWest = bounds.getSouthWest();

          const { data } = await oRest.get(
            `${API_URL}kemenag_peta_sebaran_by_bounds&latFrom=${southWest.lat}&latTo=${nortEast.lat}&longFrom=${southWest.lng}&longTo=${nortEast.lng}`
          );

          setMarkers({
            type: 3,
            data: data.map((e) => ({
              center: [e.lat, e.lon],
              data: {
                pesantren: e.pesantren,
                alamat: e.alamat,
                id: e.id,
              },
            })),
          });
        }
      } catch (error) {
        console.log(error);
        message.error("Terjadi kesalahan");
      }
    };
    fetchData();
  }, [zoom, bounds]);

  // Fetching data by ID for Modal detail
  useEffect(() => {
    const fetchData = () => {
      oRest
        .get(
          `${API_URL}kemenag_detail_pesantren_by_id&keyword=${focusPesantren}`
        )
        .then(({ data }) => {
          const temp = { ...data[0] };
          setModalDetail(temp);
          setIsModalVisible(true);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi Kesalahan");
        })
        .finally(() => {
          setFocusPesantren(null);
          setIsLoading(false);
        });
    };
    if (focusPesantren != null) fetchData();
  }, [focusPesantren]);

  const renderMarker = (type, data) => {
    switch (type) {
      case 1:
        return (
          <div>
            {data.map((e, idx) => {
              const orangeIcon = L.divIcon({
                className: "marker-custom",
                html:
                  '<div class="marker-custom">' +
                  `<img class="marker__img" src="${process.env.PUBLIC_URL}/assets/logo/orange_marker.png"/>` +
                  `<span class="marker__content">${e.content}</span>` +
                  "</div>",
              });
              const yellowIcon = L.divIcon({
                className: "marker-custom",
                html:
                  '<div class="marker-custom">' +
                  `<img class="marker__img" src="${process.env.PUBLIC_URL}/assets/logo/yellow_marker.png"/>` +
                  `<span class="marker__content">${e.content}</span>` +
                  "</div>",
              });
              const greenIcon = L.divIcon({
                className: "marker-custom",
                html:
                  '<div class="marker-custom">' +
                  `<img class="marker__img" src="${process.env.PUBLIC_URL}/assets/logo/green_marker.png"/>` +
                  `<span class="marker__content">${e.content}</span>` +
                  "</div>",
              });
              let tempIcon = greenIcon;

              if (e.content > 300) {
                tempIcon = orangeIcon;
              } else if (e.content > 150) {
                tempIcon = yellowIcon;
              }
              return (
                <Marker position={e.center} key={idx} icon={tempIcon}>
                  <Popup className="marker text-default">
                    <Row
                      className="marker__item"
                      justify="start"
                      align="middle"
                      gutter={8}
                    >
                      {e.info}
                      <br />
                      {`${e.content} Pesantren`}
                    </Row>
                    <Row justify="center">
                      <Col>
                        <Button
                          onClick={() => {
                            map.setView(e.center, 11);
                            map.closePopup(this);
                          }}
                        >
                          Perbesar
                        </Button>
                      </Col>
                    </Row>
                  </Popup>
                </Marker>
              );
            })}
          </div>
        );
      case 2:
        return (
          <div>
            {data.map((e, idx) => {
              const orangeIcon = L.divIcon({
                className: "marker-custom",
                html:
                  '<div class="marker-custom">' +
                  `<img class="marker__img" src="${process.env.PUBLIC_URL}/assets/logo/orange_marker.png"/>` +
                  `<span class="marker__content">${e.content}</span>` +
                  "</div>",
              });
              const yellowIcon = L.divIcon({
                className: "marker-custom",
                html:
                  '<div class="marker-custom">' +
                  `<img class="marker__img" src="${process.env.PUBLIC_URL}/assets/logo/yellow_marker.png"/>` +
                  `<span class="marker__content">${e.content}</span>` +
                  "</div>",
              });
              const greenIcon = L.divIcon({
                className: "marker-custom",
                html:
                  '<div class="marker-custom">' +
                  `<img class="marker__img" src="${process.env.PUBLIC_URL}/assets/logo/green_marker.png"/>` +
                  `<span class="marker__content">${e.content}</span>` +
                  "</div>",
              });
              let tempIcon = greenIcon;

              if (e.content > 50) {
                tempIcon = orangeIcon;
              } else if (e.content > 20) {
                tempIcon = yellowIcon;
              }
              return (
                <Marker position={e.center} key={idx} icon={tempIcon}>
                  <Popup className="marker text-default">
                    <Row
                      className="marker__item"
                      justify="start"
                      align="middle"
                      gutter={8}
                    >
                      {e.info}
                      <br />
                      {`${e.content} Pesantren`}
                    </Row>
                    <Row justify="center">
                      <Col>
                        <Button
                          onClick={() => {
                            map.setView(e.center, 13);
                            map.closePopup(this);
                          }}
                        >
                          Perbesar
                        </Button>
                      </Col>
                    </Row>
                  </Popup>
                </Marker>
              );
            })}
          </div>
        );
      case 3:
        return (
          <MarkerClusterGroup
            spiderfyOnMaxZoom={false}
            showCoverageOnHover={false}
            disableClusteringAtZoom={19}
          >
            {data.map((e, idx) => (
              <Marker position={e.center} key={idx}>
                <Popup className="marker text-default">
                  <Row
                    className="marker__item"
                    justify="start"
                    align="middle"
                    gutter={[24, 24]}
                  >
                    <Col span={4}>
                      <BiHome size={24} />
                    </Col>
                    <Col span={20}>{e.data.pesantren}</Col>
                  </Row>
                  <Row
                    className="marker__item"
                    justify="start"
                    align="middle"
                    gutter={[24, 24]}
                  >
                    <Col span={4}>
                      <GoLocation size={24} />
                    </Col>
                    <Col span={20}>{e.data.alamat}</Col>
                  </Row>
                  <Row justify="center">
                    <Col>
                      <Button
                        loading={isLoading}
                        onClick={() => {
                          setIsLoading(true);
                          setFocusPesantren(e.data.id);
                        }}
                      >
                        Lihat Detail
                      </Button>
                    </Col>
                  </Row>
                </Popup>
              </Marker>
            ))}
          </MarkerClusterGroup>
        );
      default:
        return <div />;
    }
  };

  return (
    <div>
      {renderMarker(markers.type, markers.data)}
      {/* <Marker position={[9, 112]} icon={orangeIcon} /> */}
      <Modal
        title="Detail Data Pondok Pesantren"
        visible={isModalVisible}
        footer={null}
        width={1048}
        onCancel={() => {
          setIsModalVisible(false);
        }}
      >
        {functions.renderDetail(modalDetail)}
      </Modal>
    </div>
  );
};

export default MarkerCluster;
